import { SUPABASE_URL, SUPABASE_KEY, getAnonHeaders, getDbHeaders } from "./client";

// Check whether an account is locked before attempting sign-in (anon, pre-auth).
export async function dbCheckLockout(email) {
  const res = await fetch(SUPABASE_URL + "/rest/v1/rpc/check_login_lockout", {
    method: "POST",
    headers: getAnonHeaders(),
    body: JSON.stringify({ p_email: email }),
  });
  if (!res.ok) return { locked: false, attempts: 0 };
  return res.json();
}

// Record a failed login attempt (anon, pre-auth).
// Returns { locked: bool, attempts: number }.
export async function dbRecordFailedLogin(email, airline) {
  const res = await fetch(SUPABASE_URL + "/rest/v1/rpc/record_failed_login", {
    method: "POST",
    headers: getAnonHeaders(),
    body: JSON.stringify({ p_email: email, p_airline: airline }),
  });
  if (!res.ok) return { locked: false, attempts: 0 };
  return res.json();
}

// Clear the caller's own attempt record after a successful sign-in.
// Must be called with the just-issued JWT (before the auth state updates the cache).
export async function dbResetLoginAttempts(token) {
  await fetch(SUPABASE_URL + "/rest/v1/rpc/reset_login_attempts", {
    method: "POST",
    headers: {
      "Content-Type":  "application/json",
      "apikey":        SUPABASE_KEY,
      "Authorization": "Bearer " + token,
    },
    body: JSON.stringify({}),
  });
}

// Fetch all undismissed lockout alerts (admin only).
export async function dbGetLoginAlerts() {
  const res = await fetch(SUPABASE_URL + "/rest/v1/rpc/get_login_alerts", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({}),
  });
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

// Mark an alert as dismissed.
export async function dbDismissLoginAlert(id) {
  await fetch(SUPABASE_URL + "/rest/v1/rpc/dismiss_login_alert", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({ p_id: id }),
  });
}

// Delete a user's lockout record so they can sign in again.
export async function dbUnlockLogin(email) {
  await fetch(SUPABASE_URL + "/rest/v1/rpc/unlock_login", {
    method: "POST",
    headers: await getDbHeaders(),
    body: JSON.stringify({ p_email: email }),
  });
}
